<template>
  <div id="overlay">
    <div class="loading text-xs-center" :class="payment ? 'payment' : ''">
      <v-progress-circular
        size="80"
        :width="4"
        :key="theme.color"
        indeterminate
        :color="theme.color"
      ></v-progress-circular>
      <p v-if="payment" style="font-size: 18px; line-height: 2" class="mt-3">
        ระบบกำลังประมวลผล กรุณารอสักครู่ อย่าพึ่งปิดหน้าต่างนี้
      </p>
    </div>

    <!-- color="white" -->
  </div>
</template>

<script>
import config from '@/config'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import { mapGetters } from 'vuex'
export default {
  props: ['payment'],
  data: function () {
    return {
      config: {
        color: config.color
      }
    }
  },
  components: {
    SyncLoader
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    })
  },
  mounted: function () {
    this.addClass('body', 'modal-open')
  },
  destroyed: function () {
    this.removeClass('body', 'modal-open')
  }
}
</script>

<style>
#overlay {
  position: fixed; /* Sit on top of the page content */
  /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.payment {
  background: #fff;
  border-radius: 20px;
  width: 39vh;
  padding: 20px;
}
</style>
